var a = /* @__PURE__ */ ((e) => (e.ClaimableReward = "ClaimableReward", e.HostedWalletReward = "HostedWalletReward", e.GameServerReward = "GameServerReward", e))(a || {});
export {
  a as GiftCodeRewardType
};
//# sourceMappingURL=giftCode.js.map
